import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'react-bootstrap'
import { FileUploader } from './'

class ModalUploader extends React.Component {
  constructor(...args) {
    super(...args)
    this.sending = false
  }

  onFinish = (url, res) => {
    this.sending = false
    this.props.onFinish(url, res)
  }
  onError = (url, error) => {
    this.sending = false
    this.props.onError(url, error)
  }
  onSend = (url, name) => {
    this.sending = true
  }

  close = () => {
    if (this.sending) return
    this.props.onFinish(this.props.url, null)
  }

  render() {
    const { url, params, accept } = this.props

    return (
      <Modal show={this.props.show} onHide={this.close}>
        <Modal.Header closeButton><Modal.Title>File Uploader</Modal.Title></Modal.Header>
        <Modal.Body>
          <div className='font-size-9'>{url}</div>
          <FileUploader
            url={url}
            accept={accept}
            params={params}
            placeholder='Select file...'
            onSend={this.onSend}
            onFinish={this.onFinish}
            onError={this.onError}
            bsStyle='info'
            className='btn-outline'
          />
        </Modal.Body>
        <Modal.Footer>
          <Button bsSize='sm' bsStyle='info' className='btn-outline' onClick={this.close}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

ModalUploader.defaultProps = {
  accept: '*',
  show: false,
  onFinish: () => {},
}

ModalUploader.propTypes = {
  url: PropTypes.string.isRequired,
  accept: PropTypes.string,
  show: PropTypes.bool,
  onFinish: PropTypes.func,
}

export default ModalUploader



// WEBPACK FOOTER //
// ./src/components/widgets/ModalUploader.js